<script lang="ts">
    import { fly } from "svelte/transition";
    import LL from "../../../../i18n/i18n-svelte";

    interface Props {
        onnext?: () => void;
    }

    const { onnext }: Props = $props();

    function handleNext() {
        onnext?.();
    }
</script>

<div class="fixed bottom-20 -right-10 transform -translate-x-14 z-3001 pointer-events-auto">
    <div
        data-testid="onboarding-card"
        class="bg-mlight/80 shadow-light rounded-md2 backdrop-blur-lg p-4 sm:p-6 w-full max-w-[550px] border border-white/20"
        in:fly={{ y: 10, duration: 400 }}
    >
        <div class="text-center">
            <h3 class="text-lg sm:text-[32px] sm:leading-7 font-bold text-mdark mb-3">
                {$LL.onboarding.screenSharing.title()}
            </h3>
            <p class="text-base text-mdark/90 m-0">
                {$LL.onboarding.screenSharing.description()}
            </p>
            {#if $LL.onboarding.screenSharing.video()}
                <!-- <video autoplay muted loop class="w-full rounded-lg my-5">
                    <source src={$LL.onboarding.screenSharing.video()} type="video/mp4" />
                </video> -->
                <img
                    class="w-full rounded-lg my-5 h-[280px]"
                    src="./static/images/Onboarding_ScreenSharing.png"
                    alt="Onboarding_ScreenSharing"
                />
            {/if}
            <!-- <p class="text-xs text-white/70 italic">
                {$LL.onboarding.screenSharing.hint()}
            </p> -->
            <button
                class="px-5 py-3 bg-mblue hover:bg-mblue-darker text-white rounded-lg font-medium transition-all text-[13px]"
                onclick={handleNext}
            >
                {$LL.onboarding.screenSharing.next()}
            </button>
        </div>
    </div>
</div>
